import { handleError } from "../../App";
import { WORKER_TYPES } from "../../constants";
import {
	FAILED_STATUS,
	SUCCESS_STATUS,
} from "../../MachineLearning/BackgroundTrainer";
import { getWorker } from "../../MachineLearning/getWorker";

export async function calcCustomTopicsDataInBkg(
	sentences,
	topics,
	cloudData,
	prevPlotPoints,
	docs,
	state
) {
	const payload = {
		workerType: WORKER_TYPES.customTopics,
		sentences: sentences,
		topics: topics,
		cloudData: cloudData,
		prevPlotPoints: prevPlotPoints,
		docs: docs,
	};
	state.setIsTopicsProcessing(true);
	let t0 = performance.now();
	const worker = getWorker();
	let customTopicsData = undefined;

	let resolves = {};
	let workerStatus = FAILED_STATUS;
	worker.onmessage = function (message) {
		if (message.data?.status === SUCCESS_STATUS) {
			customTopicsData = message.data.customTopicsData;
			resolves[0]();
			delete resolves[0];
			workerStatus = SUCCESS_STATUS;
		} else {
			handleError(state, message.data?.error, WORKER_TYPES.customTopics);
			resolves[0]();
			delete resolves[0];
		}
	};

	await new Promise(function (resolve, reject) {
		// save callbacks for later
		resolves[0] = resolve;
		worker.postMessage(payload);
	});
	if (workerStatus !== SUCCESS_STATUS) {
		state.setIsTopicsProcessing(false);
		return;
	}
	// Setting data
	const ndx = state.saveState.topicModeling.varSelected;
	const visData = state.saveState.dataset.visualizationData[ndx];
	visData.customTopicsData = customTopicsData;
	state.setIsTopicsProcessing(false);
	state.setSaveState(state.saveState, true);
}
